module.exports = __webpack_public_path__ + "static/acludata-f4e8b00038e1741a04ce1aa9cf9e39a7.png";